@if ((weatherService.observation$ | async); as observation;) {
  <div mat-content class="mat-body-2">
    <mat-card>
      <mat-card-title class="top-title">
        Wind & Wetter
      </mat-card-title>
      <mat-card-content>
        <div class="observation-line">
          <span class="icon"><i
          class="wi {{(weatherService.metar$ | async) | weatherDescriptionIconName:observation}} weather-icon"></i>
        </span>
        <span class="value">{{
          (weatherService.metar$ | async) | weatherDescriptionSimplifiedText
        }}</span>
      </div>
      <div class="observation-line">
        <span class="icon"><i class="wi wi-thermometer weather-icon"></i></span>
        <span class="value">{{observation.temperatureC}}</span>
        <span class="unit">°C</span>
      </div>
      <div class="observation-line">
        <span class="icon"><i
        class="wi wi-wind-beaufort-{{weatherSupportService.windSpeedKtToBeaufort(observation.windSpeedKt)}} weather-icon"></i></span>
        <span class="value">{{ observation.windSpeedKt }}</span>
        <span class="unit">kt</span>
      </div>
      @if (
        weatherService.metar$ | async | weatherObservationWindGusts
        ) {
        <div class="observation-line">
          <span class="icon"><i class="wi wi-small-craft-advisory weather-icon"></i></span>
          <span class="value">in Böen
            {{
            weatherService.metar$ | async | weatherObservationWindGusts
          }}</span>
          <span class="unit">kn</span>
        </div>
      }
      @if (observation.windDirection !== 'VRB') {
        <div class="observation-line">
          <span class="icon"><i class="wi wi-wind from-{{observation.windDirection}}-deg weather-icon"></i></span>
          <span class="value">{{observation.windDirection}}° </span>
          <span class="unit">{{weatherSupportService.windAngleToWindDirection(observation.windDirection)}}</span>
        </div>
      }
      @if (observation.windDirection === 'VRB') {
        <div class="observation-line">
          <span class="icon"><i class="wi wi-wind-direction weather-icon"></i></span>
          <span class="value">umlaufend</span>
        </div>
      }
    </mat-card-content>
  </mat-card>
  <div class="actions">
    <button mat-button color="accent" routerLink="/wetter"><i
    class="wi {{(weatherService.metar$ | async) | weatherDescriptionIconName:observation}} weather-icon"></i>
  Mehr zu Wind & Wetter</button>
</div>
</div>
}